import { render, staticRenderFns } from "./question.vue?vue&type=template&id=6fdfd208&scoped=true&"
import script from "./question.vue?vue&type=script&lang=js&"
export * from "./question.vue?vue&type=script&lang=js&"
import style0 from "./question.vue?vue&type=style&index=0&lang=css&"
import style1 from "./question.vue?vue&type=style&index=1&id=6fdfd208&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fdfd208",
  null
  
)

export default component.exports